const STANCER_PAYMENT_ORIGINS = [
  'https://payment.stancer.com',
  'http://payment.stancer.com',
];

const AUTHORIZED_STATUSES = new Set([
  'authorized',
  'to_capture',
  'capture_sent',
  'captured',
  'finished',
  'success',
  'payment-success',
]);

export function isStancerOrigin(origin) {
  if (!origin || typeof origin !== 'string') return false;
  return STANCER_PAYMENT_ORIGINS.some(
    (base) => origin === base || origin.startsWith(`${base}/`),
  );
}

export function isStancerPaymentAuthorized(data) {
  if (data == null) return false;
  if (typeof data === 'string') {
    return AUTHORIZED_STATUSES.has(data.toLowerCase());
  }
  if (typeof data !== 'object') return false;
  const record = data;
  const status = String(
    record.status ?? record.paymentStatus ?? record.state ?? '',
  ).toLowerCase();
  if (AUTHORIZED_STATUSES.has(status)) return true;
  if (record.authorized === true || record.success === true) return true;
  const event = String(record.event ?? record.type ?? '').toLowerCase();
  if (event.includes('success') || event.includes('authorized')) return true;
  return false;
}
